<template>
  <!-- 顶部导航栏 + 搜索 -->
  <header class="top-nav">
    <span class="nav-title">{{ pageTitle }}</span>
    <div class="nav-right">
      <div class="search-slide" :class="{ show: showSearchBox }">
        <el-input
            v-model="name"
            :placeholder="placeholder || '搜索课程'"
            @change="search"
        ></el-input>
      </div>

      <!-- 搜索图标：由路由控制是否显示 -->
      <img
          v-if="showSearchIcon"
          @click="showSearchBox = !showSearchBox"
          src="@/assets/search.png"
          alt="搜索"
      >

      <!-- 用户头像 -->
      <div class="user-avatar">
        <img :src="info.headimg" alt="用户头像"/>
      </div>
    </div>
  </header>
</template>

<script>
  import { userInfo } from '@/api/api'

  export default {
    name: "Header",
    props: {
      pageTitle: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        default: ""
      },
      showSearchIcon: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        info: {},
        showSearchBox: false, // 控制搜索框展开/收起
        name: ""
      }
    },
    mounted() {
      this.getUserInfo()
    },
    methods: {
      // 获取用户信息
      getUserInfo() {
        userInfo().then(res => {
          this.info = res.data
        }).catch(() => {})
      },
      // 搜索提交
      search() {
        this.$emit('searchList', this.name)
      }
    }
  }
</script>

<style scoped lang="less">
  .top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 0 4px; /* 轻微内边距防止贴边 */
  }

  .nav-title {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
  }

  .nav-right {
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;
  }

  .search-slide {
    width: 0;
    overflow: hidden;
    transition: width 0.3s ease;

    &.show {
      width: 180px;
    }
  }

  .user-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>
